<template>
	<div class="title-page">
		<h1 class="title">Mes CIL</h1>
		<router-link to="/franchise/ajouter" class="button outline normal">Créer un CIL</router-link>
	</div>
	<div class="card white large no-pdg">
		<div class="file-ctn">
			<h2>Liste de mes CILs</h2>
		</div>
		<div v-if="cils.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun CIL pour le moment</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun CIL trouvé" />
		</div>
		<div v-else-if="filteredCils.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun CIL trouvé</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun CIL trouvé" />
		</div>
		<div v-else class="category" v-for="category in filteredCategories" :key="category.name">
			<h3 @click="toggleCategoryVisibility(category.name)">
				{{ category.name }}
				<i class="bi"
					:class="{ 'bi-caret-right-fill': !visibleCategories[category.name], 'bi-caret-down-fill': visibleCategories[category.name] }"></i>
			</h3>
			<div v-if="visibleCategories[category.name]" class="types"
				style="grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));">
				<div v-for="cil in category.cils" :key="cil.ID" class="card white pdg-25">
					<div class="title-ctn">
						<h4>{{ cil.name }}</h4>
						<div>
							<i class="file-icon bi bi-pencil-square" @click="openViewPopup(cil)"></i>
						</div>
					</div>
					<p class="file-info">{{ cil.address }}</p>
					<p class="file-info">Email: {{ cil.User.email }}</p>
					<div class="dpe file-info">
						<div :class="['dpe-letter', getDPEColor(cil.Etiquette_DPE)]">
							{{ getDPELetter(cil.Etiquette_DPE, cil.Etiquette_GES) }}
						</div>
					</div>
					<div v-for="file in cil.files.filter(file => file !== null)" :key="file.ID" class="file-entry">
						<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
						<i v-else class="bi bi-file-image-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<i class="file-icon bi bi-download" @click="downloadFile(file.ID)"></i>
						<i class="file-icon bi bi-eye-fill" @click="viewFile(file.ID)"></i>
						<i class="file-icon bi bi-trash-fill" @click="openPopup(file.ID)"></i>
					</div>
				</div>
				<router-link to="/franchise/ajouter" class="card transparent">
					<i class="bi bi-plus-circle-dotted" style="font-size: 50px; color: #000"></i>
				</router-link>
			</div>
		</div>
	</div>
	<ModifierCIL :isVisible="showViewPopup" title="Modifier un CIL" :cil="showViewCIL" @confirm2="closeViewPopup"
		@cancel2="closeViewPopup"></ModifierCIL>
	<ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir supprimer ce fichier ?" @confirm="deleteLastFile" @cancel="closePopup">
	</ConfirmationPopup>
</template>

<script>
import ModifierCIL from "@/franchise-pages/ModifierCIL.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";

export default {
	name: "MaFranchise",
	props: ['searchQuery'],
	components: {
		ModifierCIL,
		ConfirmationPopup,
	},
	data() {
		return {
			cils: [],
			showViewCIL: {},
			showViewPopup: false,
			visibleCategories: {},
			fileToDelete: "",
			showPopup: false,
		};
	},
	created() {
		this.fetchAllCILs();
	},
	methods: {
		initializeVisibleCategories() {
			if (!('En attente' in this.visibleCategories)) {
				this.visibleCategories["En attente"] = false;
			}
			if (!('Acceptés' in this.visibleCategories)) {
				this.visibleCategories["Acceptés"] = true;
			}
		},
		toggleCategoryVisibility(categoryName) {
			this.visibleCategories[categoryName] = !this.visibleCategories[categoryName];
		},
		async fetchAllCILs() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "franchise/agency/cil", { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.cils = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
					this.initializeVisibleCategories();
				}
			} catch (error) {
				this.message = "Une erreur est survenue.";
			}
		},
		getDPELetter(dpe, ges) {
			const letters = [];
			if (dpe) letters.push(dpe);
			if (ges) letters.push(ges);

			if (letters.length === 0) return "-";

			return letters.sort()[letters.length - 1];
		},
		getDPEColor(letter) {
			switch (letter) {
				case "A":
					return "color-A";
				case "B":
					return "color-B";
				case "C":
					return "color-C";
				case "D":
					return "color-D";
				case "E":
					return "color-E";
				case "F":
					return "color-F";
				case "G":
					return "color-G";
				default:
					return "color-Z";
			}
		},
		openViewPopup(cil) {
			this.showViewCIL = cil;
			this.showViewPopup = true;
		},
		closeViewPopup() {
			this.fetchAllCILs();
			this.showViewCIL = {};
			this.showViewPopup = false;
		},
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "franchise/read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "franchise/download/" + fileId;
			window.open(url, "_blank");
		},
		openPopup(fileId) {
			this.fileToDelete = fileId;
			this.showPopup = true;
		},
		closePopup() {
			this.showPopup = false;
		},
		async deleteLastFile() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "franchise/fichier/delete/" + this.fileToDelete, { method: "GET", credentials: "include", });
				if (!response.ok) {
					alert("Erreur : " + this.fileToDelete);
				} else {
					this.closePopup();
					this.fileToDelete = "";
					this.fetchAllCILs();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
	},
	computed: {
		filteredCils() {
			const query = this.searchQuery.toLowerCase();
			return this.cils.filter(cil =>
				cil.name.toLowerCase().includes(query) ||
				cil.address.toLowerCase().includes(query) ||
				cil.User.email.toLowerCase().includes(query)
			);
		},
		filteredCategories() {
			const categories = {
				"En attente": [],
				"Acceptés": []
			};
			this.filteredCils.forEach(cil => {
				if (cil.pending) {
					categories["En attente"].push(cil);
				} else {
					categories["Acceptés"].push(cil);
				}
			});
			return Object.keys(categories)
				.filter(name => categories[name].length > 0)
				.map(name => ({
					name,
					cils: categories[name]
				}));
		}
	},
};
</script>



<style scoped>
.head {
	display: flex;
	margin-bottom: 30px;
}

.head>div {
	padding-left: 25px;
	font-size: 14px;
	font-weight: bold;
	color: #a7a7a7;
}

.head>div:nth-child(-n + 4) {
	position: relative;
}

.head>div:nth-child(-n + 4)::after {
	content: "";
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 1px;
	height: 25px;
	background-color: #ccc;
}

.head .dpe {
	min-width: 50px;
}

.head .name,
.head .address {
	min-width: 225px;
}

.head .email {
	min-width: 250px;
}

.head .address {
	flex: 1;
}

.head .status {
	width: 100px;
}

.head .action {
	width: 125px;
}

.logement-list {
	display: flex;
	flex-direction: column;
	gap: 25px;
}

.logement-line {
	display: flex;
	align-items: center;
	background-color: #fff;
	border-radius: 15px;
	filter: drop-shadow(0 0 5px #d3d3d3);
	height: 60px;
}

.logement-line>div {
	padding: 0 25px;
}

.logement-line>div:nth-child(-n + 4) {
	position: relative;
}

.logement-line>div:nth-child(-n + 4)::after {
	content: "";
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 1px;
	height: 35px;
	background-color: #ccc;
}

.logement-line .dpe {
	display: flex;
	align-items: center;
	justify-content: center;
}

.dpe-letter {
	font-size: 20px;
	color: white;
	border-radius: 5px;
	padding: 5px;
	width: 15px;
	text-align: center;
}

.logement-line .name,
.logement-line .address,
.logement-line .email {
	min-width: 200px;
	font-weight: bold;
}

.logement-line .address {
	flex: 1;
}

.logement-line .status {
	min-width: 75px;
}

.logement-line .action {
	width: 100px;
}
</style>
